import { Component, ViewChild, OnDestroy, AfterViewInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef, OnInit, ElementRef, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { GestionInterface, PlanificadorService } from '../control.service';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, Subject } from 'rxjs';
import { auditTime, takeUntil } from 'rxjs/operators';
import { NgxDatatableModule, DatatableComponent } from '@swimlane/ngx-datatable';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
/* import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'; */
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { TableVirtualScrollDataSource, TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { MatSort, Sort, MatSortModule } from '@angular/material/sort';
import { CdkTable, CdkTableModule } from '@angular/cdk/table';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { MatDialog } from '@angular/material/dialog';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { GraficaModeloComponent } from '../../graficas/grafica-modelo/grafica-modelo.component';
import { Router } from '@angular/router';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { GestionService } from 'src/app/services/gestion.services';
import { BrokerService } from 'src/app/services/broker.services';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { TemaService } from 'src/app/services/tema.services';
import { EliminaropeDialogComponent } from '../../eliminarope-dialog/eliminarope-dialog.component';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr'; // Asegúrate de importar ToastrService

/** Lotes del SSE ya transformados para un flujo (ver filasDesdeLotes). */
interface CacheLotes {
  origen: any[] | null;
  lotes: number;
  filas: any[];
}

@Component({
  selector: 'app-planificador-gestion',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.scss'],
  // Gestor/Broker disparan detección de cambios cada segundo y con cada mensaje del socket;
  // con OnPush la tabla solo se revisa cuando cambian sus datos o hay un evento suyo.
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanificadorGestionComponent implements OnChanges, OnDestroy, OnInit {

  private destroy$ = new Subject<void>();
  private cachePla: CacheLotes = { origen: null, lotes: 0, filas: [] };
  private cacheDiv: CacheLotes = { origen: null, lotes: 0, filas: [] };
  private cacheGest: CacheLotes = { origen: null, lotes: 0, filas: [] };
  private cacheBrok: CacheLotes = { origen: null, lotes: 0, filas: [] };
  private fechaScrollTimer: any;

  // Column resize state
  private isColResizing = false;
  private colResizeStartX = 0;
  private colResizeStartWidth = 0;
  private colResizeTargetTh: HTMLElement | null = null;
  private documentMouseMoveUnlisten: (() => void) | null = null;
  private documentMouseUpUnlisten: (() => void) | null = null;

  private opesubcription: Subscription;
  private fechaSubcription: Subscription;
  private SubfechaBuscador: Subscription;
  private divFechaSubcription: Subscription;
  private modelSub: Subscription;
  private divOpeSub: Subscription;
  private gestOpeSub: Subscription;
  private gestFechaSub: Subscription;
  private brokOpeSub: Subscription;
  private brokFechaSub: Subscription;
  public optimalWallet: OptimalWallet;
  public optimaBroker: OptimalWallet;
  private subOptimaGest: Subscription;
  private subBrokOptima: Subscription;
  currentDate: string;

  public modeloMercat: any;
  dataSource: MatTableDataSource<operationinterface>; //pruebas en el mattable
  filaSeleccionada: any;
  public nombreComp: string = '';

  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
  // @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;

  /*DATATABLE ANGULAR */
  @ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();


  /*MATTABLE */
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestion!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestionDiv!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestionGest!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestionBrok!: CdkVirtualScrollViewport;
  calculatingScrollOffset: boolean = false;
  initialOffset: number = 500;
  @ViewChild(MatSort) sort!: MatSort;

  public datasourceNew = new TableVirtualScrollDataSource;
  public opedata = new CdkTableVirtualScrollDataSource<operationinterface>;
  public divOpeData = new CdkTableVirtualScrollDataSource<operationinterface>;
  public gestOpeData = new CdkTableVirtualScrollDataSource<operationinterface>;
  public brokOpeData = new CdkTableVirtualScrollDataSource<operationinterface>;

  //OCULTAR COLuMNAS
  tableColumnsPl: TableColmuns[] = [
    { id: 'contador', name: '#', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cartera', name: 'Modelo', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'tipomodelo', name: 'Tipo Modelo', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'isooper', name: 'ID', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'nombreCompania', name: 'Nombre', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'secType', name: 'secType', isShow: false, isDate: false, isNumber:false, isString: true},
    { id: 'fechaOperacion', name: 'Fecha', isShow: true, isDate: true, isNumber: false, isString: false },
    { id: 'tipoOperacion', name: 'Tipo', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'precioentradareal', name: 'Precio Entrada', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'stoplossinicial', name: 'Stop loss', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'profit', name: 'Profit', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'preciosalidareal', name: 'Precio Salida', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'posicionsimultanea', name: 'Cartera', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'cantidadacciones', name: 'N° Acciones', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'comision', name: 'Comision', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'acumuladocomision', name: 'Acum Comision', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'costeoperacion', name: 'Coste operacion', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'beneficioperdida', name: 'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'beneficioacumulado', name: 'Acumulado', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'costereembolso', name: 'Reembolso Coste', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'riesgooperacion', name: 'Riesgo Operacion', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorriesgo', name: 'Valor Riesgo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'tiporiesgo', name: 'Tipo Riesgo', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'margentotal', name: 'Margen Total', isShow: false, isDate: false, isNumber: true, isString: false },  
    { id: 'podercompra', name: 'Poder Adquisitivo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'reembolsoriesgo', name: 'Reembolso Riesgo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'riesgomaximo', name: 'Riesgo Maximo', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'fondosdisponibles', name: 'Fondos Disponibles', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorliquidativo', name: 'Valor Liquidativo', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'efectivo', name: 'Efectivo', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorlatente', name: 'Valor Latente', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'contractSizeLote', name: 'Precio * ContractSize * Lote', isShow: false, isDate: false, isNumber: true, isString: false }

  ]

  displayedColumnsPl: string[] = ['contador','isooper', 'nombreCompania', 'fechaOperacion',
    'tipoOperacion', 'precioentradareal', 'beneficioperdida', 'beneficioacumulado',
    'riesgooperacion', 'riesgomaximo', 'fondosdisponibles', 'valorliquidativo',
    'efectivo', 'valorlatente'];

  tableColumns: TableColmuns[] = [
    { id: 'contador', name: '#', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cartera', name: 'Modelo', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'tipomodelo', name: 'Tipo Modelo', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'isooper', name: 'ID', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'nombreCompania', name: 'Nombre', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'secType', name: 'secType', isShow: false, isDate: false, isNumber:false, isString: true},
    { id: 'fechaOperacion', name: 'Fecha', isShow: true, isDate: true, isNumber: false, isString: false },
    { id: 'tipoOperacion', name: 'Tipo', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'precioentradareal', name: 'Precio Entrada', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'stoplossinicial', name: 'Stop loss', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'profit', name: 'Profit', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'preciosalidareal', name: 'Precio Salida', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'posicionsimultanea', name: 'Cartera', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'cantidadacciones', name: 'N° Acciones', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'comision', name: 'Comision', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'acumuladocomision', name: 'Acum Comision', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'costeoperacion', name: 'Coste operacion', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'beneficioperdida', name: 'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'beneficioacumulado', name: 'Acumulado', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'costereembolso', name: 'Reembolso Coste', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'riesgooperacion', name: 'Riesgo Operacion', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorriesgo', name: 'Valor Riesgo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'tiporiesgo', name: 'Tipo Riesgo', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'margentotal', name: 'Margen Total', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'podercompra', name: 'Poder Adquisitivo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'reembolsoriesgo', name: 'Reembolso Riesgo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'riesgomaximo', name: 'Riesgo Maximo', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'fondosdisponibles', name: 'Fondos Disponibles', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorliquidativo', name: 'Valor Liquidativo', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'efectivo', name: 'Efectivo', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorlatente', name: 'Valor Latente', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'contractSizeLote', name: 'Precio * ContractSize * Lote', isShow: false, isDate: false, isNumber: true, isString: false }

  ]

  displayedColumns: string[] = ['contador', 'isooper', 'nombreCompania', 'secType','fechaOperacion',
    'tipoOperacion', 'precioentradareal', 'beneficioperdida', 'beneficioacumulado',
    'riesgooperacion', 'valorriesgo', 'tiporiesgo', 'riesgomaximo', 'fondosdisponibles', 'valorliquidativo',
    'efectivo', 'valorlatente'];



  @ViewChild(MatPaginator) paginator: MatPaginator;


  @Input() selectedTab: number = 0;
  @Input() loading: boolean = false;
  @Input() modelo: boolean = false;
  @Input() isPlanificador: boolean = false;
  @Input() isGestion: boolean = false;
  @Input() isBroker: boolean = false;
  /** Solo true cuando este componente vive dentro de Models (ver models.component.html) — habilita que seleccionar una fila cargue el activo+modelo en la pestaña "Gráfica Análisis" embebida. Diversificador/Gestor/Broker lo dejan en false. */
  @Input() habilitarGraficaEmbebida: boolean = false;

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  scrollActSetByUser: boolean = false;

  @Input() filter: string | null = null;
  @Input() mensaje: string;
  public OpeNew: any;
  public originalDataPla: any[] = [];
  public isProcPla: boolean;
  public isACtualPla: boolean;
  private subProcPLa: Subscription;
  private subActualPla: Subscription;

  public originalDataDiv: any[] = [];
  public isProcDiv: boolean =false;
  public isACtualDiv: boolean =false;
  private subisProcDiv: Subscription;
  private subisACtualDiv: Subscription;

  public originalDataGest: any[] = [];
  public isProcBrok: boolean =false;
  public isACtualBrok: boolean =false;
  private subisProcBrok: Subscription;
  private subisACtualBrok: Subscription;

  public isProcGest: boolean =false;
  public isACtualGest: boolean =false;
  private subisProcGest: Subscription;
  private subisACtualGest: Subscription;

  public originalDataBrok: any[] = [];

  selectedRows: any[] = [];
  scrollTop: number = 50;
  private indexToScrollTo: number = 0;
  private scrollAct: number;
  columnVisibility: { [key: string]: boolean } = {};
  indexGes: number;
  indexGesDiv: number;
  indexGestion: number;
  indexBrok: number;
  queryParams: string;
  isDark: boolean = false;
  subTemaService: Subscription;
  contadorFilas: number;
  theme: any;
  licencia: string;



  constructor( private toastr: ToastrService ,
    public planificadorsv: PlanificadorService,
    private change: ChangeDetectorRef,
    private diversificadorsv: DiversificadorService,
    private _gestionsv: GestionService,
    private _brokersv: BrokerService,
    private _sseService: SseService,
    private _cookieService: CookieService,
    private temaservicio: TemaService,
    public dialog: MatDialog,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.subProcPLa = this.planificadorsv.valIsProc$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isProcPla=data; this.change.markForCheck();}});
    this.subActualPla = this.planificadorsv.valisACtual$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isACtualPla=data; this.change.markForCheck();}})

    this.subisProcDiv = this.diversificadorsv.valIsProc$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isProcDiv=data; this.change.markForCheck();}});
    this.subisACtualDiv = this.diversificadorsv.valisACtual$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isACtualDiv=data; this.change.markForCheck();}})

    this.subisProcGest = this._gestionsv.valIsProc$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isProcGest=data; this.change.markForCheck();}});
    this.subisACtualGest = this._gestionsv.valisACtual$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isACtualGest=data; this.change.markForCheck();}})

    this.subisProcBrok = this._brokersv.valIsProc$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isProcBrok=data; this.change.markForCheck();}});
    this.subisACtualBrok = this._brokersv.valisACtual$.pipe(takeUntil(this.destroy$)).subscribe({next: (data: any)=>{this.isACtualBrok=data; this.change.markForCheck();}})

  }

  ngAfterViewInit(): void {
    // Initialize header column resizing for tables inside this component
    this.initColumnResizing();
  }

  private initColumnResizing(): void {
    try {
      const root: HTMLElement = (this.el && this.el.nativeElement) || document;
      const tables: NodeListOf<HTMLTableElement> = root.querySelectorAll('table');
      tables.forEach(table => {
        const ths = table.querySelectorAll('th');
        ths.forEach((th: Element) => {
          // ensure pointer cursor
          (th as HTMLElement).style.cursor = 'col-resize';
          // attach mousedown
          this.renderer.listen(th, 'mousedown', (ev: MouseEvent) => this.onHeaderMouseDown(ev, th as HTMLElement, table));
        });
      });
    } catch (e) {
      // ignore
    }
  }

  private onHeaderMouseDown(event: MouseEvent, th: HTMLElement, table: HTMLTableElement): void {
    // Only left button
    if (event.button !== 0) return;
    event.preventDefault();
    this.isColResizing = true;
    this.colResizeTargetTh = th;
    this.colResizeStartX = event.clientX;
    this.colResizeStartWidth = th.offsetWidth;

    // attach global listeners
    this.documentMouseMoveUnlisten = this.renderer.listen('document', 'mousemove', (ev: MouseEvent) => this.onDocumentMouseMove(ev, table));
    this.documentMouseUpUnlisten = this.renderer.listen('document', 'mouseup', () => this.onDocumentMouseUp());
  }

  private onDocumentMouseMove(event: MouseEvent, table: HTMLTableElement): void {
    if (!this.isColResizing || !this.colResizeTargetTh) return;
    const delta = event.clientX - this.colResizeStartX;
    let newWidth = this.colResizeStartWidth + delta;
    if (newWidth < 40) newWidth = 40; // min width
    // apply width to header cell
    this.colResizeTargetTh.style.width = newWidth + 'px';

    // apply to body cells in same column index
    const ths = Array.from(this.colResizeTargetTh.parentElement!.children) as HTMLElement[];
    const index = ths.indexOf(this.colResizeTargetTh);
    if (index >= 0) {
      const rows = Array.from(table.querySelectorAll('tr'));
      rows.forEach(row => {
        const cells = Array.from(row.children) as HTMLElement[];
        if (cells[index]) {
          cells[index].style.width = newWidth + 'px';
        }
      });
    }
  }

  private onDocumentMouseUp(): void {
    this.isColResizing = false;
    this.colResizeTargetTh = null;
    if (this.documentMouseMoveUnlisten) { this.documentMouseMoveUnlisten(); this.documentMouseMoveUnlisten = null; }
    if (this.documentMouseUpUnlisten) { this.documentMouseUpUnlisten(); this.documentMouseUpUnlisten = null; }
  }

  ngOnInit(): void {
    this.licencia = this._cookieService.get('auth_token');

    // Las operaciones llegan del SSE en lotes (cada 200 periodos) y cada emisión trae todo lo
    // acumulado. auditTime agrupa los lotes seguidos (siempre entrega el último) y cada instancia
    // solo procesa su propio flujo: los BehaviorSubject retienen datos de las otras pantallas.
    //-------------------PLANIFICADOR---------------------
    this.opesubcription = this.planificadorsv.operation$.pipe(auditTime(150), takeUntil(this.destroy$)).subscribe(
      (newdata: any) => {
        if (!this.modelo) return;
        this.OpeNew = newdata;
        this.originalDataPla = this.filasDesdeLotes(this.cachePla, newdata);
        this.filterData();
      });

    this.fechaSubcription = this.planificadorsv.valFechaFiltro$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.scrollToFirstDate(data);
      }
    });
    this.SubfechaBuscador = this.planificadorsv.valfechaBuscador$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (date: any) => {
        this.indexGes = this.opedata.data.findIndex(item => item.fechaOperacion === date);
        if (this.viewportGestion) { this.viewportGestion.scrollToIndex(this.indexGes - 5); }
      }
    });
    this.modelSub = this.planificadorsv.getModelMercat().pipe(takeUntil(this.destroy$)).subscribe(
      datos => {

        this.modeloMercat = datos;
      });

    //------------------DIVERSIFICADOR-----------------------
    this.divOpeSub = this.diversificadorsv.valDivOp$.pipe(auditTime(150), takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        if (!this.isPlanificador) return;
        this.originalDataDiv = this.filasDesdeLotes(this.cacheDiv, data);
        this.filterData();
      }
    );
    this.divFechaSubcription = this.diversificadorsv.valDivFechaFiltro$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.scrollToFirstDate(data);
      }
    });
    //------------------------- GESTOR --------------------------------
    this.gestOpeSub = this._gestionsv.valGestOp$.pipe(auditTime(150), takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        if (!this.isGestion) return;
        this.originalDataGest = this.filasDesdeLotes(this.cacheGest, data);
        this.filterData();
      }
    });
    this.gestFechaSub = this._gestionsv.valGestFechaFiltro$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.scrollToFirstDate(data);
      }
    });
    this.subOptimaGest = this._gestionsv.valgestOptimaWallet$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.optimalWallet = data;
      }
    })
    //---------------------- BROKER ------------------------------------
    this.brokOpeSub = this._brokersv.valBrokOp$.pipe(auditTime(150), takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
          if (!this.isBroker) return;
          this.originalDataBrok = this.filasDesdeLotes(this.cacheBrok, data);
          this.filterData();
      }
    });
    this.brokFechaSub = this._brokersv.valBrokFechaFiltro$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.scrollToFirstDate(data);
      }
    });
    this.subBrokOptima = this._brokersv.valBrokOptimaWallet$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any)=>{
        this.optimaBroker=data;
      }
    });
    //---------------------TEMA-----------------------
    this.subTemaService = this.temaservicio.valDarkTheme.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
        this.change.markForCheck();
      }
    });
  }

  /**
   * Durante un SSE los padres hacen ope.push(lote) sobre el mismo array y lo vuelven a emitir:
   * con la misma referencia solo se transforman los lotes nuevos. Rehacer (y copiar) todo lo
   * acumulado en cada lote era coste cuadrático. Otra referencia (recálculo, reset) rehace todo.
   */
  private filasDesdeLotes(cache: CacheLotes, data: any[]): any[] {
    if (!Array.isArray(data)) data = [];
    if (cache.origen !== data || data.length < cache.lotes) {
      cache.origen = data;
      cache.lotes = 0;
      cache.filas = [];
    }
    const nuevos = data.slice(cache.lotes);
    cache.lotes = data.length;
    if (nuevos.length > 0) {
      cache.filas = cache.filas.concat(this.agregaTiporModelo(this.flattenArray(nuevos)));
    }
    return cache.filas;
  }

  agregaTiporModelo(data :any[] ): any[] {

    return data.map(data => {
      if (data && typeof data.bajista === 'boolean') {
        const updatedOperation = {
          ...data,
          tipomodelo: data.bajista ? 'Bajista ↓' : 'Alcista ↑',
        };
  
        // Si 'bajista' es true, agrega la flecha hacia abajo al final de 'tipoOperacion'
        if (data.bajista && typeof data.tipoOperacion === 'string' ) {
          if(data.tipoOperacion === 'SALIDA'){

            updatedOperation.tipoOperacion = `ENTRADA ↓`;

          } else if( data.tipoOperacion === 'ENTRADA'){
            updatedOperation.tipoOperacion = `SALIDA ↓`;

          }

        }else if (!data.bajista && typeof data.tipoOperacion === 'string'){
          if(data.tipoOperacion === 'SALIDA' || data.tipoOperacion === 'ENTRADA') {
            updatedOperation.tipoOperacion = `${data.tipoOperacion} ↑`;
          }
         
        }
  
        return updatedOperation;
      } else {
        throw new Error("El objeto no tiene la propiedad 'bajista' o no es un string.");
      }
    });
  }

  toggleProcGest(): void {
    this.isProcGest = !this.isProcGest;
    this.filterData();
  }

  toggleActualGest(): void {
    this.isACtualGest = !this.isACtualGest;
    this.filterData();
  }

  // Se asigna .data en vez de crear un DataSource nuevo: la tabla conserva su suscripción y
  // las filas ya pintadas, y no se recrean todas en cada lote.
  filterData() {

    if(this.modelo){
      this.opedata.data = this.filtrarOperaciones(this.originalDataPla, this.isProcPla, this.isACtualPla);
      this.planificadorsv.updateIsACtual(this.isACtualPla);
      this.planificadorsv.updateIsProc(this.isProcPla);
    }
    if(this.isPlanificador){
      this.divOpeData.data = this.filtrarOperaciones(this.originalDataDiv, this.isProcDiv, this.isACtualDiv);
      this.diversificadorsv.updateIsACtual(this.isACtualDiv);
      this.diversificadorsv.updateIsProc(this.isProcDiv);
    }
    if(this.isGestion){
        this.gestOpeData.data = this.filtrarOperaciones(this.originalDataGest, this.isProcGest, this.isACtualGest);
        this._gestionsv.updateIsACtual(this.isACtualGest);
        this._gestionsv.updateIsProc(this.isProcGest);
    }
    if(this.isBroker){
        this.brokOpeData.data = this.filtrarOperaciones(this.originalDataBrok, this.isProcBrok, this.isACtualBrok);
        this._gestionsv.updateIsACtual(this.isACtualBrok);
        this._gestionsv.updateIsProc(this.isProcBrok);
    }
    this.change.detectChanges();
  }

  /** procesados: solo procesadas e INICIAL; actualizaciones: incluir las de tipo ACTUALIZACION. */
  private filtrarOperaciones(origen: any[], procesados: boolean, actualizaciones: boolean): operationinterface[] {
    const filas = origen.filter(item =>
      (!procesados || item.procesado || item.tipoOperacion === "INICIAL") &&
      (actualizaciones || item.tipoOperacion !== "ACTUALIZACION"));
    return this.updateCounter(filas);
  }


  scrollToFirstDate(date: string) {
    if (this.modelo) {
      this.indexGes = this.opedata.data.findIndex(item => item.fechaOperacion === date);
    }
    else if (this.isPlanificador) { this.indexGesDiv = this.divOpeData.data.findIndex(item => item.fechaOperacion === date); }
    else if (this.isGestion) { this.indexGestion = this.gestOpeData.data.findIndex(item => item.fechaOperacion === date); }
    else if (this.isBroker) { this.indexBrok = this.brokOpeData.data.findIndex(item => item.fechaOperacion === date); }

  }

  updateCounter(data: operationinterface[]): operationinterface[] {
    this.contadorFilas = -1; // Reinicia el contador del lote
    return data.map(item => {
      item.contador = ++this.contadorFilas
      ; // Incrementa y asigna el contador del lote
      return item;
    });
  }
  

  flattenArray(arrayOfArrays: any[]): any[] {

    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  ngOnChanges(changes: SimpleChanges): void {
  
    if (this.selectedTab === 0) {
      this.actualizarViewport();
      this.change.detectChanges();
      if (this.modelo) {
        if (this.indexGes !== -1) {
          if (this.viewportGestion) { this.viewportGestion.scrollToIndex(this.indexGes - 5); }
        }
      } else if (this.isPlanificador) {
        if (this.indexGesDiv !== -1) {
          if (this.viewportGestionDiv) { this.viewportGestionDiv.scrollToIndex(this.indexGesDiv - 5); }
        }
      } else if (this.isGestion) {
        if (this.indexGestion !== -1) {
          if (this.viewportGestionGest) { this.viewportGestionGest.scrollToIndex(this.indexGestion - 5); }
        }
      } else if (this.isBroker) {
        if (this.indexBrok !== -1) {
          if (this.viewportGestionBrok) { this.viewportGestionBrok.scrollToIndex(this.indexBrok - 5); }
        }
      }

    }
  }

  selectRow(row: any) {
    this.filaSeleccionada = row;
    if (this.modelo) { this.planificadorsv.updateFechaFiltro(this.filaSeleccionada.fechaOperacion); }
    if (this.isPlanificador) { this.diversificadorsv.updateDivFechaFiltro(this.filaSeleccionada.fechaOperacion); }
    else if (this.isGestion) { this._gestionsv.updategestFechaFiltro(this.filaSeleccionada.fechaOperacion); }
    else if (this.isBroker) { this._brokersv.updateBrokFechaFiltro(this.filaSeleccionada.fechaOperacion) }

    if (this.habilitarGraficaEmbebida && row?.idmodelo > 0) {
      this.planificadorsv.updateModeloSeleccionadoGrafica({
        idNectum: row.idNectum,
        nombreComp: row.nombreCompania,
        idModelo: row.idmodelo,
        isModelo: 'modelo',
        fecha: row.fechaOperacion
      });
    }
  }


  ngOnDestroy() {

    // takeUntil cubre todas las suscripciones; antes quedaban varias vivas y cada instancia
    // destruida seguía reteniendo sus filas.
    this.destroy$.next();
    this.destroy$.complete();
    this.dtTrigger.unsubscribe();
    clearTimeout(this.fechaScrollTimer);

    // clean up any document listeners for column resizing
    if (this.documentMouseMoveUnlisten) { this.documentMouseMoveUnlisten(); this.documentMouseMoveUnlisten = null; }
    if (this.documentMouseUpUnlisten) { this.documentMouseUpUnlisten(); this.documentMouseUpUnlisten = null; }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  panelOpenState = false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  step = 0;
  showcolumn(idcolumn: string) {
    this.columnVisibility[idcolumn] = !this.columnVisibility[idcolumn];
  }

  toggleColumnVisibility(id: any) {
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
    }
  }
  toggleColumnVisibility2(id: any){
    const column = this.tableColumnsPl.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumnsPl = this.tableColumnsPl.filter(col => col.isShow).map(col => col.id);
    }
  }

  actualizarViewport() {
    if (this.viewportGestion) {
      this.viewportGestion.checkViewportSize();
      this.viewportGestion.checkViewportSize();
    }
    else if (this.viewportGestionDiv) {
      this.viewportGestionDiv.checkViewportSize();
      this.viewportGestionDiv.checkViewportSize();
    }
    else if (this.viewportGestionGest) {
      this.viewportGestionGest.checkViewportSize();
      this.viewportGestionGest.checkViewportSize();
    }
    else if (this.viewportGestionBrok) {
      this.viewportGestionBrok.checkViewportSize();
      this.viewportGestionBrok.checkViewportSize();
    }
  }

  verModelo() {
    if (this.filaSeleccionada.idmodelo > 0) {
      const jsonData = {
        idNectum: this.filaSeleccionada.idNectum,
        nombreComp: this.filaSeleccionada.nombreCompania,
        idModelo: this.filaSeleccionada.idmodelo,
        isModelo: 'modelo',
        fecha: this.filaSeleccionada.fechaOperacion
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    } else {
      this.toastr.error('Selecciona correctamente el activo para ver modelo.', 'Aviso', {
        timeOut: 3000,
        positionClass: 'toast-top-right'
      });
    }
  }

  verGrafica() {
    const jsonData = {
      idNectum: this.filaSeleccionada.idNectum,
      nombreComp: this.filaSeleccionada.nombreCompania,
      idModelo: '0',
      isModelo: 'grafica'
    };
    this.queryParams = new URLSearchParams(jsonData).toString();
    window.open('/grafica-modelo/' + this.queryParams, '_blank');

  }
  dialogEliminar(broker: boolean) {

    let operacion = JSON.parse(JSON.stringify(this.filaSeleccionada));
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    let auth = this._cookieService.get('auth_token');

    const dialogRef = this.dialog.open(EliminaropeDialogComponent, {
      width: '420px',
      maxHeight: '90vh',
      panelClass: dialogClass,
      data: {
        operacion: operacion, token: auth, broker: broker
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró dialogEliminar', result);
      if (result) {

        if(broker && this.isBroker){
          console.log("broker && this.isBroker");
          this._brokersv.updateactualizarCarteraBroker(result);
        }
        if(this.isGestion && !broker){
          console.log("this.isGestion && !broker");
          this._gestionsv.updateactualizarCartera(result);
        }
      } else {
        // Lógica a ejecutar si se cancela la acción
        console.log('La acción fue cancelada');
      }
    });

  }
  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
    console.log(this.filaSeleccionada);
  }

  
  limpiar(){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: '¡Atencion! Todos los datos de operaciones se Eliminaran'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        this._sseService.apiPostNew('limpiar', {}, this.licencia).subscribe({

        });
      }
    });
  }
  mostrarFechaScroll(index: any){
    //console.log(index)
    const intIndex = Math.floor(index+5);
    //console.log('Índice entero:', intIndex);
    let item = null;
    if(this.modelo)
    item = this.opedata.data[intIndex];
    if(this.isGestion)
      item = this.gestOpeData.data[intIndex];
    if(this.isBroker)
      item = this.brokOpeData.data[intIndex];
    if(this.isPlanificador)
      item = this.divOpeData.data[intIndex];
    //console.log("item item", item)
    if (item && item.fechaOperacion) {
      this.currentDate = item.fechaOperacion;
      // Un solo temporizador: antes se creaba uno por evento de scroll, y cada uno disparaba
      // detección de cambios en toda la app 10 s después.
      clearTimeout(this.fechaScrollTimer);
      this.fechaScrollTimer = setTimeout(() => {
        this.currentDate = '';
        this.change.markForCheck();
      }, 10000);
    }
  }



}
